import { clipLeadGenAdOverlayTitle } from "./lead-gen-focus";
import {
  leadAdFooterLayout,
  leadGenAdOverlayTitleWidth,
} from "./lead-gen-ad-measure";
import { VENTURU_LEAD_AD_LOGO } from "./lead-ad-venturu-logo";

/** Shared footer policy and geometry for the browser and composed PNGs. */
export function resolveLeadAdFooter(input: {
  cardInnerWidth: number;
  logoUrl?: string | null;
  licenseBadge?: string | null;
  preferVenturuLogo?: boolean;
  licenseFontSize: number;
}): {
  licenseBadge: string | null;
  venturuLogoUrl: string | null;
  rightWidth: number;
  logoMaxWidth: number;
  showDivider: boolean;
} {
  const licenseBadge = input.preferVenturuLogo
    ? null
    : input.licenseBadge?.trim() || null;
  const venturuLogoUrl = licenseBadge ? null : VENTURU_LEAD_AD_LOGO;
  const layout = leadAdFooterLayout({
    cardInnerWidth: input.cardInnerWidth,
    licenseText: licenseBadge,
    licenseFontSize: input.licenseFontSize,
  });
  const rightWidth = venturuLogoUrl ? 180 : layout.licenseWidth;
  const showDivider = Boolean(input.logoUrl);
  return {
    licenseBadge,
    venturuLogoUrl,
    rightWidth,
    // Two 14px gaps surround the 1px divider.
    logoMaxWidth: Math.max(0, input.cardInnerWidth - rightWidth - 29),
    showDivider,
  };
}

/** Preserve an explicit broker title, fitting its full text instead of dropping words. */
export function resolveLeadAdTitle(input: {
  title: string;
  brokerTitle?: string | null;
  fontSize: number;
  maxWidth: number;
}): { text: string; fontSize: number } {
  const custom = input.brokerTitle?.trim();
  if (!custom)
    return {
      text: clipLeadGenAdOverlayTitle(input.title),
      fontSize: input.fontSize,
    };
  const width = (leadGenAdOverlayTitleWidth(custom) * input.fontSize) / 28;
  return {
    text: custom,
    fontSize: Math.min(
      input.fontSize,
      (input.fontSize * input.maxWidth) / Math.max(width, 1),
    ),
  };
}
